<!-- <div class="toolbar" role="banner">
  <img width="40" alt="Angular Logo" src="../assets/images/image.ico"/>
  <span>Welcome {{name}},</span>
  <div class="spacer">
    <span style="float: right !important; margin: 2vh;">{{examname}}</span>
  </div>
</div>
<div class="" role="main">
  <div style="position: relative; top: 10vh;">
    <app-question-page-header></app-question-page-header>
  </div> -->
  <div class="overlay" [ngClass]="{'show': isLoading}" aria-hidden="true"></div>
  <div class="spanner" [ngClass]="{'show': isLoading}" role="status" aria-live="polite"
    [attr.aria-label]="language.loadingWait">
    <!-- <div class="loader"></div> -->
    <div class="spin-wrap">
      <div class="spin-wrap-content">
        <div class="spinner-container" aria-hidden="true">
          <div class="lds-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
<link *ngFor="let layoutFile of layoutFiles; let i = index" rel="preload" as="style" [href]="layoutFile.safeUrl"
  (load)="customCssLoaded(i)" (error)="customCssErrored(i)">
<link *ngFor="let activeLayoutFile of activeLayoutFiles" rel="stylesheet" [href]="activeLayoutFile.safeUrl">
<div *ngIf="showsebpb" id="seb-quit-button-div"><span>{{language.quitSebMessage}}<i class="fa fa-arrow-right" aria-hidden="true"></i>
    <button (click)="quitseb()" aria-labelledby="seb-quit-instruction" [attr.aria-label]="language.quitSeb">
      <i class="fa fa-sharp fa-power-off" style="cursor: pointer;" aria-hidden="true"></i></button></span></div>
<router-outlet></router-outlet>
<div id="recaptcha-footer" aria-hidden="true"></div>
<!-- </div> -->
